export const SEARCH_PARAMS_SUCCESS = 'SEARCH_PARAMS_SUCCESS'
